import { useDjango } from './useDjango'

export const useApi = () => {
  const { api } = useDjango()
  return { api }
}
